<div class="stepper-container" *ngIf="showStepper">
  <div class="stepper-track">
    <div 
      *ngFor="let step of steps; let i = index" 
      class="step-line"
      [class.active]="i === currentStep"
      [class.completed]="i < currentStep">
    </div>
  </div>
</div>
